
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
	name: 'EventBanner',
	components: {},
})
export default class EventBanner extends Vue {
	get bannerImage() {
		return `url(/${ASSETS_DIR}/img/jw-sports-banner-placeholder.png)`;
	}
}
